/* eslint-disable react/prop-types */
import React from 'react';
import {
    Grid,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    FormHelperText,
    Checkbox,
    ListItemText,
    OutlinedInput,
    Box,
    FormLabel,
    Typography,
    Collapse,
    IconButton,
    Autocomplete,
    TextField,
    Chip
} from '@mui/material';
import SubCard from 'ui-component/cards/SubCard';
import { gridSpacing, roles } from 'store/constant';
import {
    cooling,
    disclosures,
    documentsAvailable,
    heating,
    meterDescription,
    ownerPaysList,
    sewer,
    tenantPays,
    utilitiesList,
    waterSource
} from './data/document_data';
import HelpIcon from './HelpIcon';
import { tips } from './HelpData';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import AgentOfficeInformation from './Agent';

const DocumentsInfo = ({ errors, handleSubmit, handleChange, handleBlur, isSubmitting, values, touched, setFieldValue, role }) => {
    const [openOptional, setOpenOptional] = React.useState(true);

    const handleToggle = () => {
        setOpenOptional((prev) => !prev);
    };

    return (
        <Grid item xs={12}>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <Typography
                        sx={{
                            color: '#919191',
                            fontSize: '16px',
                            fontStyle: 'normal',
                            fontWeight: '700',
                            lineHeight: 'normal',
                            textTransform: 'capitalize',
                            mb: 2
                        }}
                    >
                        Documents & Utilities Information
                    </Typography>
                    <SubCard sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth required error={touched.cooling && Boolean(errors.cooling)}>
                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                Cooling
                                            </Typography>
                                        </FormLabel>
                                        <HelpIcon
                                            title={tips.Cooling.title}
                                            ruleHelp={tips.Cooling.ruleHelp}
                                            generalHelpDesc={tips.Cooling.generalHelpDesc}
                                            generalHelp={tips.Cooling.generalHelp}
                                        />
                                    </Box>
                                    <Autocomplete
                                        renderTags={(tagValue, getTagProps) =>
                                            tagValue.map((option, index) => (
                                                <Chip
                                                    key={index}
                                                    label={option}
                                                    {...getTagProps({ index })}
                                                    sx={{
                                                        '& .MuiChip-deleteIcon': {
                                                            color: 'black !important'
                                                        }
                                                    }}
                                                />
                                            ))
                                        }
                                        multiple
                                        options={cooling}
                                        value={values.cooling}
                                        onChange={(event, newValue) => setFieldValue('cooling', newValue)}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" error={touched.cooling && Boolean(errors.cooling)} />
                                        )}
                                        disableCloseOnSelect
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox checked={selected} />
                                                <ListItemText primary={option} />
                                            </li>
                                        )}
                                    />
                                    {touched.cooling && errors.cooling && <FormHelperText>{errors.cooling}</FormHelperText>}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth required error={touched.sewer && Boolean(errors.sewer)}>
                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                Sewer Or Septic Features
                                            </Typography>
                                        </FormLabel>
                                        <HelpIcon {...tips.Sewer} />
                                    </Box>
                                    <Autocomplete
                                        renderTags={(tagValue, getTagProps) =>
                                            tagValue.map((option, index) => (
                                                <Chip
                                                    key={index}
                                                    label={option}
                                                    {...getTagProps({ index })}
                                                    sx={{
                                                        '& .MuiChip-deleteIcon': {
                                                            color: 'black !important'
                                                        }
                                                    }}
                                                />
                                            ))
                                        }
                                        multiple
                                        options={sewer}
                                        value={values.sewer}
                                        onChange={(event, newValue) => setFieldValue('sewer', newValue)}
                                        onBlur={handleBlur}
                                        renderInput={(params) => <TextField {...params} error={touched.sewer && Boolean(errors.sewer)} />}
                                        disableCloseOnSelect
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox checked={selected} />
                                                <ListItemText primary={option} />
                                            </li>
                                        )}
                                    />
                                    {touched.sewer && errors.sewer && <FormHelperText>{errors.sewer}</FormHelperText>}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth required error={touched.disclosures && Boolean(errors.disclosures)}>
                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                Disclosures
                                            </Typography>
                                        </FormLabel>
                                        <HelpIcon {...tips.disclosures} />
                                    </Box>
                                    <Autocomplete
                                        renderTags={(tagValue, getTagProps) =>
                                            tagValue.map((option, index) => (
                                                <Chip
                                                    key={index}
                                                    label={option}
                                                    {...getTagProps({ index })}
                                                    sx={{
                                                        '& .MuiChip-deleteIcon': {
                                                            color: 'black !important'
                                                        }
                                                    }}
                                                />
                                            ))
                                        }
                                        multiple
                                        options={disclosures}
                                        value={values.disclosures}
                                        onChange={(event, newValue) => setFieldValue('disclosures', newValue)}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField {...params} error={touched.disclosures && Boolean(errors.disclosures)} />
                                        )}
                                        disableCloseOnSelect
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox checked={selected} />
                                                <ListItemText primary={option} />
                                            </li>
                                        )}
                                    />
                                    {touched.disclosures && errors.disclosures && <FormHelperText>{errors.disclosures}</FormHelperText>}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth required error={touched.utilities && Boolean(errors.utilities)}>
                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                Utilities
                                            </Typography>
                                        </FormLabel>
                                        <HelpIcon {...tips.Utilities} />
                                    </Box>
                                    <Autocomplete
                                        renderTags={(tagValue, getTagProps) =>
                                            tagValue.map((option, index) => (
                                                <Chip
                                                    key={index}
                                                    label={option}
                                                    {...getTagProps({ index })}
                                                    sx={{
                                                        '& .MuiChip-deleteIcon': {
                                                            color: 'black !important'
                                                        }
                                                    }}
                                                />
                                            ))
                                        }
                                        multiple
                                        options={utilitiesList}
                                        value={values.utilities}
                                        onChange={(event, newValue) => setFieldValue('utilities', newValue)}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField {...params} error={touched.utilities && Boolean(errors.utilities)} />
                                        )}
                                        disableCloseOnSelect
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox checked={selected} />
                                                <ListItemText primary={option} />
                                            </li>
                                        )}
                                    />
                                    {touched.utilities && errors.utilities && <FormHelperText>{errors.utilities}</FormHelperText>}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth required error={touched.ownerPays && Boolean(errors.ownerPays)}>
                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                Owner Pays
                                            </Typography>
                                        </FormLabel>
                                        <HelpIcon {...tips.OwnerPays} />
                                    </Box>
                                    <Autocomplete
                                        renderTags={(tagValue, getTagProps) =>
                                            tagValue.map((option, index) => (
                                                <Chip
                                                    key={index}
                                                    label={option}
                                                    {...getTagProps({ index })}
                                                    sx={{
                                                        '& .MuiChip-deleteIcon': {
                                                            color: 'black !important'
                                                        }
                                                    }}
                                                />
                                            ))
                                        }
                                        multiple
                                        options={ownerPaysList}
                                        value={values.ownerPays}
                                        onChange={(event, newValue) => setFieldValue('ownerPays', newValue)}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField {...params} error={touched.ownerPays && Boolean(errors.ownerPays)} />
                                        )}
                                        disableCloseOnSelect
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox checked={selected} />
                                                <ListItemText primary={option} />
                                            </li>
                                        )}
                                    />
                                    {touched.ownerPays && errors.ownerPays && <FormHelperText>{errors.ownerPays}</FormHelperText>}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth required error={touched.tenantPays && Boolean(errors.tenantPays)}>
                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                Tenant Pays
                                            </Typography>
                                        </FormLabel>
                                        <HelpIcon {...tips.TenantPays} />
                                    </Box>
                                    <Autocomplete
                                        renderTags={(tagValue, getTagProps) =>
                                            tagValue.map((option, index) => (
                                                <Chip
                                                    key={index}
                                                    label={option}
                                                    {...getTagProps({ index })}
                                                    sx={{
                                                        '& .MuiChip-deleteIcon': {
                                                            color: 'black !important'
                                                        }
                                                    }}
                                                />
                                            ))
                                        }
                                        multiple
                                        options={tenantPays}
                                        value={values.tenantPays}
                                        onChange={(event, newValue) => setFieldValue('tenantPays', newValue)}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField {...params} error={touched.tenantPays && Boolean(errors.tenantPays)} />
                                        )}
                                        disableCloseOnSelect
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox checked={selected} />
                                                <ListItemText primary={option} />
                                            </li>
                                        )}
                                    />
                                    {touched.tenantPays && errors.tenantPays && <FormHelperText>{errors.tenantPays}</FormHelperText>}
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={12} sm={4}>
                            <FormControl fullWidth error={touched.groundwaterConservDistrict && Boolean(errors.groundwaterConservDistrict)}>
                                <InputLabel id="groundwaterConservDistrict-label">Groundwater Conserv District</InputLabel>
                                <Select
                                    labelId="groundwaterConservDistrict-label"
                                    id="groundwaterConservDistrict"
                                    name="groundwaterConservDistrict"
                                    value={values.groundwaterConservDistrict}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Groundwater Conserv District"
                                >
                                    <MenuItem value="Yes">Yes</MenuItem>
                                    <MenuItem value="No">No</MenuItem>
                                </Select>
                                {touched.groundwaterConservDistrict && errors.groundwaterConservDistrict && (
                                    <FormHelperText>{errors.groundwaterConservDistrict}</FormHelperText>
                                )}
                            </FormControl>
                        </Grid> */}
                        </Grid>
                    </SubCard>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            cursor: 'pointer',
                            mb: 2,
                            p: 1,
                            background: 'white'
                        }}
                        onClick={handleToggle}
                    >
                        <Typography
                            sx={{
                                color: '#919191',
                                fontSize: '16px',
                                fontWeight: '700',
                                textTransform: 'capitalize'
                            }}
                        >
                            Optional Information
                        </Typography>
                        <IconButton>{openOptional ? <ExpandLess /> : <ExpandMore />}</IconButton>
                    </Box>

                    <Collapse in={openOptional}>
                        <SubCard sx={{ pt: '20px' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <FormControl fullWidth error={touched.documentsAvailable && Boolean(errors.documentsAvailable)}>
                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Documents Available
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips.documentsAvailable.title}
                                                ruleHelp={tips.documentsAvailable.ruleHelp}
                                                generalHelpDesc={tips.documentsAvailable.generalHelpDesc}
                                            />
                                        </Box>
                                        <Autocomplete
                                            renderTags={(tagValue, getTagProps) =>
                                                tagValue.map((option, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={option}
                                                        {...getTagProps({ index })}
                                                        sx={{
                                                            '& .MuiChip-deleteIcon': {
                                                                color: 'black !important'
                                                            }
                                                        }}
                                                    />
                                                ))
                                            }
                                            multiple
                                            disableCloseOnSelect
                                            options={documentsAvailable}
                                            value={values.documentsAvailable}
                                            onChange={(event, newValue) => {
                                                setFieldValue('documentsAvailable', newValue);
                                            }}
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props}>
                                                    <Checkbox checked={selected} />
                                                    <ListItemText primary={option} />
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    error={touched.documentsAvailable && Boolean(errors.documentsAvailable)}
                                                />
                                            )}
                                        />
                                        {touched.documentsAvailable && errors.documentsAvailable && (
                                            <FormHelperText>{errors.documentsAvailable}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <FormControl fullWidth error={touched.heating && Boolean(errors.heating)}>
                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Heating
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips.Heating.title}
                                                ruleHelp={tips.Heating.ruleHelp}
                                                generalHelpDesc={tips.Heating.generalHelpDesc}
                                            />
                                        </Box>
                                        <Autocomplete
                                            renderTags={(tagValue, getTagProps) =>
                                                tagValue.map((option, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={option}
                                                        {...getTagProps({ index })}
                                                        sx={{
                                                            '& .MuiChip-deleteIcon': {
                                                                color: 'black !important'
                                                            }
                                                        }}
                                                    />
                                                ))
                                            }
                                            multiple
                                            disableCloseOnSelect
                                            options={heating}
                                            value={values.heating}
                                            onChange={(event, newValue) => {
                                                setFieldValue('heating', newValue);
                                            }}
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props}>
                                                    <Checkbox checked={selected} />
                                                    <ListItemText primary={option} />
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    error={touched.heating && Boolean(errors.heating)}
                                                />
                                            )}
                                        />
                                        {touched.heating && errors.heating && <FormHelperText>{errors.heating}</FormHelperText>}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <FormControl fullWidth error={touched.waterSource && Boolean(errors.waterSource)}>
                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Water Source
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips.WaterSource.title}
                                                ruleHelp={tips.WaterSource.ruleHelp}
                                                generalHelpDesc={tips.WaterSource.generalHelpDesc}
                                            />
                                        </Box>
                                        <Autocomplete
                                            renderTags={(tagValue, getTagProps) =>
                                                tagValue.map((option, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={option}
                                                        {...getTagProps({ index })}
                                                        sx={{
                                                            '& .MuiChip-deleteIcon': {
                                                                color: 'black !important'
                                                            }
                                                        }}
                                                    />
                                                ))
                                            }
                                            multiple
                                            disableCloseOnSelect
                                            options={waterSource}
                                            value={values.waterSource}
                                            onChange={(event, newValue) => {
                                                setFieldValue('waterSource', newValue);
                                            }}
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props}>
                                                    <Checkbox checked={selected} />
                                                    <ListItemText primary={option} />
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    error={touched.waterSource && Boolean(errors.waterSource)}
                                                />
                                            )}
                                        />
                                        {touched.waterSource && errors.waterSource && <FormHelperText>{errors.waterSource}</FormHelperText>}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <FormControl fullWidth error={touched.meterDescription && Boolean(errors.meterDescription)}>
                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Meter Description
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips.MeterDescription?.title}
                                                ruleHelp={tips.MeterDescription?.ruleHelp}
                                                generalHelpDesc={tips.MeterDescription?.generalHelpDesc}
                                            />
                                        </Box>
                                        <Autocomplete
                                            renderTags={(tagValue, getTagProps) =>
                                                tagValue.map((option, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={option}
                                                        {...getTagProps({ index })}
                                                        sx={{
                                                            '& .MuiChip-deleteIcon': {
                                                                color: 'black !important'
                                                            }
                                                        }}
                                                    />
                                                ))
                                            }
                                            multiple
                                            disableCloseOnSelect
                                            options={meterDescription}
                                            value={values.meterDescription}
                                            onChange={(event, newValue) => {
                                                setFieldValue('meterDescription', newValue);
                                            }}
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props}>
                                                    <Checkbox checked={selected} />
                                                    <ListItemText primary={option} />
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    error={touched.meterDescription && Boolean(errors.meterDescription)}
                                                />
                                            )}
                                        />
                                        {touched.meterDescription && errors.meterDescription && (
                                            <FormHelperText>{errors.meterDescription}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </SubCard>

                        {role === roles.ADMIN && (
                            <AgentOfficeInformation
                                role={role}
                                errors={errors}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                isSubmitting={isSubmitting}
                                values={values}
                                touched={touched}
                                setFieldValue={setFieldValue}
                            />
                        )}
                    </Collapse>
                </Grid>

                {errors.submit && (
                    <Grid item xs={12}>
                        <FormHelperText error>{errors.submit}</FormHelperText>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};

export default DocumentsInfo;
